import gql from 'graphql-tag';
const GET_SIGNED_URL = gql`
  query getSignedURL($key: String!) {
    getSignedURL(key: $key)
  }
`;

export default GET_SIGNED_URL;
